import { useEffect, useRef } from 'react';
if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}
export const useLastViewedElement = (storageKey) => {
    const lwKey = window.sessionStorage.getItem(storageKey);
    const lwElementRef = useRef(null);
    useEffect(() => {
        lwElementRef.current?.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
        window.sessionStorage.removeItem(storageKey);
    }, []);
    return [lwKey, lwElementRef, (key) => { window.sessionStorage.setItem(storageKey, key); }];
};
